import { Box, Stack } from "@mui/material";
import { useGlobalContext } from "../../stores/Global";
import SideBarButton from "../molecules/SideBarButton";
import SettingsIcon from "@mui/icons-material/Settings";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import Authorized from "../atoms/Authorized";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { useTranslation } from "react-i18next";
import WorkIcon from "@mui/icons-material/Work";

export const sideBarWidth = 260;

function SideBarContent() {
  const { t } = useTranslation("Navigation");
  const { context } = useGlobalContext();

  return (
    <Stack spacing={1} sx={{ p: context.sidebar ? 2 : 1 }}>
      <SideBarButton
        icon={<DashboardIcon />}
        value={t("Dashboard")}
        page="dashboard"
      />

      <SideBarButton
        icon={<ConfirmationNumberIcon />}
        value={t("Tickets")}
        page="ticket"
        filterField="status"
      />
      <SideBarButton
        icon={<StorageIcon />}
        value={t("Storage")}
        page="storage"
      />
      <Authorized role="admin">
        <SideBarButton icon={<PersonIcon />} value={t("Users")} page="user" />
        <SideBarButton
          icon={<GroupIcon />}
          value={t("Departments")}
          page="department"
        />
      </Authorized>
      <Authorized role="agent">
        <SideBarButton
          icon={<WorkIcon />}
          value={t("Business")}
          page="business"
        />
      </Authorized>
      <Authorized role="admin">
        <SideBarButton
          icon={<SettingsIcon />}
          value={t("Settings")}
          page="settings"
        />
      </Authorized>
    </Stack>
  );
}

export default function SideBar() {
  const { context } = useGlobalContext();

  return (
    <>
      <Stack
        sx={{
          height: 1,
          overflowY: "auto",
          width: context.sidebar ? sideBarWidth : undefined,
        }}
      >
        <Box flexGrow={1} overflow="auto" sx={{ overflowX: "hidden" }}>
          <SideBarContent />
        </Box>
      </Stack>
    </>
  );
}
